import { render } from "./TeamList.vue?vue&type=template&id=33ea26c2&scoped=true"
import script from "./TeamList.vue?vue&type=script&lang=js"
export * from "./TeamList.vue?vue&type=script&lang=js"

import "./TeamList.vue?vue&type=style&index=0&id=33ea26c2&lang=scss&scoped=true"
import "./TeamList.vue?vue&type=style&index=1&id=33ea26c2&lang=scss"
script.render = render
script.__scopeId = "data-v-33ea26c2"

export default script